/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateBotExamLangViewModel } from "../types/CreateBotExamLangViewModel.ts";

export const createBotExamLangViewModelSchema = z.object({
  botExamId: z.optional(
    z
      .number()
      .int()
      .describe("ID da prova bot à qual o idioma será associado."),
  ),
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura do idioma a ser criado. Deve ser um dos valores permitidos: pt-BR, en-US, es-ES. Máximo 10 caracteres.",
    )
    .nullish(),
  title: z
    .string()
    .describe("Título da prova bot neste idioma. Máximo 300 caracteres.")
    .nullish(),
  instruction: z
    .string()
    .describe("Instrução geral da prova bot neste idioma.")
    .nullish(),
  active: z.optional(
    z.boolean().describe("Define se este idioma estará ativo ao ser criado."),
  ),
}) as unknown as ToZod<CreateBotExamLangViewModel>;
